import { ValidationRule } from '@/types/vuetify/ValidationRule'
import { DateTime } from 'luxon'

export function datetime(format = 'yyyy-MM-dd HH:mm:ss'): ValidationRule {
  return (value: string) => {
    if (!value) return true

    if (value.length < 19) return 'Data inválida'
    const datetime = DateTime.fromFormat(value, format)
    return datetime.isValid || 'Campo inválido'
  }
}
